import { UPSELL_FLOWS } from './upsellEventMap'

const PENDING_UPSELL_SUCCESS_KEY = 'pendingUpsellSuccess'

export function savePendingUpsellSuccess({ flow, step } = {}) {
  if (!flow || !step) {
    return
  }

  sessionStorage.setItem(
    PENDING_UPSELL_SUCCESS_KEY,
    JSON.stringify({ flow, step }),
  )
}

export function consumePendingUpsellSuccess() {
  const raw = sessionStorage.getItem(PENDING_UPSELL_SUCCESS_KEY)

  if (!raw) {
    return null
  }

  sessionStorage.removeItem(PENDING_UPSELL_SUCCESS_KEY)

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function readUpsellSuccessFromSearch(search = '') {
  const params = new URLSearchParams(search)
  const flow = params.get('upsellFlow')
  const step = params.get('upsellStep')

  if (!flow || !step) {
    return null
  }

  return { flow, step }
}

export function resolveUpsellCheckoutSuccess(search = '') {
  return readUpsellSuccessFromSearch(search) || consumePendingUpsellSuccess()
}

export function openUpsellSuccessStep(flowRef, step) {
  if (!flowRef?.current?.openSuccessStep || !step) {
    return false
  }

  return flowRef.current.openSuccessStep(step)
}

export function openUpsellCheckoutSuccess(
  { flow, step },
  {
    campaignDownloadRef,
    artsLimitRef,
    subscribedArtsLimitRef,
  } = {},
) {
  const refByFlow = {
    [UPSELL_FLOWS.CAMPAIGN_DOWNLOAD]: campaignDownloadRef,
    [UPSELL_FLOWS.ARTS_LIMIT]: artsLimitRef,
    [UPSELL_FLOWS.SUBSCRIBED_ARTS_LIMIT]: subscribedArtsLimitRef,
  }

  return openUpsellSuccessStep(refByFlow[flow], step)
}
